import React from 'react';
import { ValidationProps } from 'ui';
import { ValidationError } from './validation-error';
import { CodeListItem } from 'app/area/indicator-factors/list/types-store';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { createFormatters } from 'app/infrastructure/data/date';
import { mapCodeParameters } from 'app/area/indicator-factors/list/duplicate-rows/map-code-parameters';
import { CodetableTranslation } from 'app/area/indicator-factors/constants';
import styles from './duplicate-rows-validation-errors.scss';

interface DuplicateRowsValidationErrorsProps {
  codeParameters: CodeListItem[];
  numberOfResults?: number;
  numberOfNotValidIndicators?: number;
  validation: { [key: string]: ValidationProps };
  locale: string;
  translation: CodetableTranslation;
}

export const DuplicateRowsValidationErrors = ({ codeParameters, numberOfResults,
  numberOfNotValidIndicators, validation, locale, translation }: DuplicateRowsValidationErrorsProps) => {

  if (!validation || !codeParameters) {
    return null;
  }

  const formatters = createFormatters(locale);

  const dateFormatter = (date: Date) => formatters.formatDate(date, {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

  return <div className={styles.container}>
    <ValidationError
      title={replaceTemplateString(
        translation.duplicate_rows_validation_title,
        numberOfNotValidIndicators,
        numberOfResults
      )}
      subtitle={translation.duplicate_rows_validation_subtitle}
      footer={<div className={styles.footer}>
        <b>{translation.duplicate_rows_validation_suggested_title}</b>
        <ul>
          <li>{translation.duplicate_rows_validation_suggested_message_first}</li>
          <li>{translation.duplicate_rows_validation_suggested_message_second}</li>
        </ul>
      </div>}
      items={mapCodeParameters(codeParameters, dateFormatter)}
    />
  </div>;
};
